import {useEffect, useState} from 'react';
import {fetchBulkPdfShipments, fetchShipmentsInDateRange} from '../infrastructure/ShipmentApi';
import {initial, isSuccess, mapRemoteData} from '../../common/domain/RemoteData.model';
import {remoteDataWithSetter} from '../../common/utils/remoteDataWithSetter';
import {lastMonthDateRange} from '../../common/domain/DateRange.model';
import {downloadBlob} from '../../helpers/downloadBlob';
import {useComercialContext} from '../../comercial/ComercialContext';

const sortByPostingDate = (shipments, order) =>
  [...shipments].sort((a, b) => {
    const diff = new Date(a.postingDate) - new Date(b.postingDate);
    return order === 'asc' ? diff : -diff;
  });

/** Mi cuenta -> Albaranes: listado por fecha de registro y descarga (una o en zip). */
export const useShipments = () => {
  const {actingAsCliente} = useComercialContext();
  const actingAsNumCliente = actingAsCliente?.numCliente ?? null;
  const [shipmentsRemoteData, setShipmentsRemoteData] = useState(initial(null));
  const [sortOrder, setSortOrder] = useState('desc');
  const [dateRange, setDateRange] = useState(lastMonthDateRange());
  const [bulkDownloadRemoteData, setBulkDownloadRemoteData] = useState(initial(null));

  const toggleSortOrder = () => setSortOrder(prev => (prev === 'asc' ? 'desc' : 'asc'));

  const downloadShipments = (shipments) => {
    const numbers = shipments.map(shipment => shipment.number);
    remoteDataWithSetter(setBulkDownloadRemoteData, () => fetchBulkPdfShipments(numbers, actingAsNumCliente)).then();
  };

  useEffect(() => {
    remoteDataWithSetter(setShipmentsRemoteData, () => fetchShipmentsInDateRange(dateRange, actingAsNumCliente)).then();
  }, [dateRange, actingAsNumCliente]);

  useEffect(() => {
    setShipmentsRemoteData(prevState =>
      mapRemoteData(prevState, shipments => shipments && sortByPostingDate(shipments, sortOrder)),
    );
  }, [sortOrder]);

  useEffect(() => {
    if (isSuccess(bulkDownloadRemoteData)) {
      downloadBlob(bulkDownloadRemoteData.value, 'albaranes.zip');
      setBulkDownloadRemoteData(initial(null));
    }
  }, [bulkDownloadRemoteData]);

  return {
    shipmentsRemoteData,
    toggleSortOrder,
    dateRange,
    setDateRange,
    downloadShipments,
    bulkDownloadRemoteData,
    actingAsNumCliente
  };
};
